export default __webpack_public_path__ + "chime.f9b7c197d4683ee8c33f02cd23c5bea9.wav";